import React from 'react';
import styled from 'styled-components';

import { NavLink } from 'react-router-dom';
// import NavigationItem from './NavigationItem/NavigationItem';}
import AppLink from '../../AppLink/AppLink';
import { mediaMin, mediaMax } from '../../Media Template/Media Template';
// import Aux from '../../Aux/Aux';

const UL = styled.ul.attrs({})`
  ${mediaMin.desktop`flex-flow: row;`};
  ${mediaMax.desktop`align-items: flex-start;`};
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-flow: column;
  align-items: center;
  /* height: 90%; */
  width: 75%;
  height: 100%;
  text-transform: uppercase;
  font-family: 'Montserrat';
  font-size: 14.2px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  /* width: 100%;
  max-width: 1000px; */
`;

const ListItem = styled.li.attrs({})`
  margin: 0;
  display: display;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 20%;
  a {
    text-decoration: none;
    color: #424242;
    width: auto;
    /* padding: 1rem 0; */
    letter-spacing: 1.2px;
    margin: 0 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-weight: 700;
  }

  ul > li > a {
    justify-content: flex-start;
    font-size: 0.8rem;
    padding: 0.3rem 0;
  }
  ul > li > a:active,
  ul > li > a.active {
    border-bottom: none;
  }

  ul {
    box-shadow: 0px 3px 3px 1px rgba(193, 193, 193, 0.5);
    display: none;
    color: #424242;
    position: relative;
    top: -5%;
    left: 0;
    list-style: none;
    background: #fff;
    padding: 0 0 0.6rem 0;
    width: 140%;
  }

  :hover ul {
    display: block;
  }
  :hover ul li {
    padding: 5px 0;
    line-height: 1.5;
    /* padding: 0; */
    /* margin: 0.5rem 0; */
  }
  :hover ul li:hover {
    color: #4db2ec;
  }

  div {
    color: #424242;
    stroke: #424242;
    /* width: 100%; */
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 1.2rem;
  }

  div:hover {
    color: #4db2ec;
    stroke: #4db2ec;
  }

  /* a:hover, */
  a:active,
  a.active {
    border-bottom: 3px solid #4db2ec;
    color: #4db2ec;
  }

  a:hover {
    color: #4db2ec;
  }
  ${mediaMax.desktop`a {border-bottom: none !important;}`};
`;

const NavigationItems = styled.div.attrs({
  className: 'flex justify-center items-center h-100'
})`
  ${mediaMax.desktop`
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    margin: 2rem 0;
    li {
      margin: 0.7rem 0;
    }
    .AppLink {
      margin: 2rem 1.2rem;
    }
  `};
  ${mediaMin.phone`width: 700px;`};
`;

const navigationItems = () => {
  return (
    <NavigationItems className="NavigationItems">
      <UL className="UL">
        <ListItem className="ListItem">
          <NavLink exact to={'/news'}>
            News
          </NavLink>
        </ListItem>
        <ListItem className="ListItem">
          <NavLink exact to={'/reviews'}>
            Reviews
          </NavLink>
        </ListItem>
        <ListItem className="ListItem">
          <NavLink exact to={'/how-to'}>
            How&nbsp;To
          </NavLink>
        </ListItem>
        {/* <ListItem className="ListItem">
          <NavLink exact to={'/best-of'}>
            Best&nbsp;Of
          </NavLink>
        </ListItem> */}
        <ListItem className="ListItem">
          <NavLink exact to={'/internet'}>
            Internet
          </NavLink>
        </ListItem>
        <ListItem className="ListItem">
          <div>
            More&nbsp;
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="5"
              viewBox="0 0 12 5"
            >
              <polyline
                fill="none"
                // stroke="#555"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="1 0 6 5 11 0"
              />
            </svg>
          </div>
          <ul className="sub-menu">
            <li>
              <NavLink exact to={'/about'}>
                About
              </NavLink>
            </li>
            <li>
              <NavLink exact to={'/careers'}>
                Careers
              </NavLink>
            </li>
            <li>
              <NavLink exact to={'/advertise'}>
                Advertise
              </NavLink>
            </li>
            <li>
              <NavLink exact to={'/contact-us'}>
                Contact&nbsp;Us
              </NavLink>
            </li>
          </ul>
        </ListItem>

        {/* 
          Featured
        
        <NavigationItem*/}
      </UL>
      <AppLink />
    </NavigationItems>
  );
};

export default navigationItems;
